import React from 'react';

export default function arrowIconLeft() {
  return (
    <svg
      className="display-block"
      viewBox="0 0 6 10"
      width="6"
      height="10"
      style={{ marginLeft: '-2px' }}
    >
      <path
        d="M5.7,8.3L2.4,5l3.3-3.3c0.4-0.4,0.4-1,0-1.4s-1-0.4-1.4,0l-4,4c-0.4,0.4-0.4,1,0,1.4l4,4
      C4.5,9.9,4.7,10,5,10s0.5-0.1,0.7-0.3C6.1,9.3,6.1,8.7,5.7,8.3z"
      />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/icons/ArrowLeft/index.js